module.exports = __webpack_public_path__ + "resources/img/img_magic_eam.d01a0fe09faf979a2e5593468dae5427.png";